<template>
  <label
    class="input-check"
    @input="sendInputEvent($event)"
    @focus="sendFocusEvent($event)"
    @blur="sendBlurEvent($event)"
    @click="sendClickEvent($event)"
    @mousedown="sendMousedownEvent($event)"
    @mouseover="sendMouseoverEvent($event)"
    @mouseout="sendMouseoutEvent($event)"
    @keydown="sendKeydownEvent($event)"
    @keyup="sendKeyupEvent($event)"
  >
    <input
      :id="id"
      type="checkbox"
      class="checkbox"
      :name="name"
      :value="value"
      :checked="value === modelValue"
      :tabindex="tabindex"
      @change="updateValue"
    />
    <span class="checktxt"><slot></slot></span>
  </label>
</template>

<script>
import {
  sendInputEvent,
  sendFocusEvent,
  sendChangeEvent,
  sendBlurEvent,
  sendClickEvent,
  sendMousedownEvent,
  sendMouseoverEvent,
  sendMouseoutEvent,
  sendKeydownEvent,
  sendKeyupEvent,
} from "@/utils/FormEvent";

export default {
  name: "InputCheck",
  props: {
    modelValue: { type: String, default: "" },
    name: { type: String, default: "" },
    id: { type: String, default: "" },
    tabindex: { type: String, default: "" },
    checked: { type: Boolean, default: false },
    value: { type: String, default: "" },
    trackingName: { type: String, default: "" },
  },
  emits: ["input", "checked", "update:modelValue"],
  setup() {
    return {
      sendInputEvent,
      sendFocusEvent,
      sendChangeEvent,
      sendBlurEvent,
      sendClickEvent,
      sendMousedownEvent,
      sendMouseoverEvent,
      sendMouseoutEvent,
      sendKeydownEvent,
      sendKeyupEvent,
    };
  },
  computed: {
    group() {
      return "$parent" in this && this.$parent.$options.name === "vue-group"
        ? this.$parent
        : null;
    },
    input() {
      return this.group ? this.group.value : this.checked;
    },
  },

  methods: {
    updateValue(e) {
      this.sendChangeEvent(e);
      let value = e.target.checked ? this.value : null;
      if (this.group) {
        this.group.$emit("input", value);
        this.group.$emit("checked", value);
        this.group.$emit("update:modelValue", value);
      } else {
        this.$emit("input", value);
        this.$emit("checked", value);
        this.$emit("update:modelValue", value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.input-check {
  > .checkbox {
    display: none;
  }

  > .checktxt {
    padding-left: 20px;
    position: relative;
    margin-right: 20px;
  }

  > .checktxt::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
    height: 16px;
    border: 1px solid $secondary;
  }

  > .checkbox:checked + .checktxt::after {
    content: "";
    display: block;
    position: absolute;
    top: 1px;
    left: 5px;
    width: 6px;
    height: 12px;
    transform: rotate(50deg);
    border-bottom: 3px solid $primary;
    border-right: 3px solid $primary;
  }
}
</style>
